import React, { useState } from "react";
import { useParams } from "react-router-dom";
import red from "@material-ui/core/colors/red";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Alert from "@material-ui/lab/Alert";
import { API_BASE_URL } from "../../constants";
import axios from "axios";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://material-ui.com/">
        SML Group Limited
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export default function PasswordReset() {
  let { userId } = useParams();

  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");

  const [id, setId] = useState(userId);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const classes = useStyles();

  const handlePassword = (text) => {
    setPassword(text);
    setError(false);
  };

  const handleConfirmPassword = (text) => {
    setConfirmPassword(text);
    setError(false);
  };

  const handleSubmit = async () => {
    if (!password) {
      setError(true);
      setMessage("Password required");
    } else if (!confirmPassword) {
      setError(true);
      setMessage("Confirm password required");
    } else if (password !== confirmPassword) {
      setError(true);
      setMessage("Password not match");
    } else {
      const data = {
        userId: userId,
        password: password,
      };

      await axios
        .post(API_BASE_URL + "reset-password", data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response) {
            setSuccess(true);
            setMessage(response.data.Message);

            setTimeout(() => {
              setPassword("");
              setConfirmPassword("");
              setSuccess(false);
              setMessage("");
            }, 2000);
          }
          console.log("response", response);
        })
        .catch((error) => {
          console.log("error", error);
          console.log("error", error.response);
        });
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        {success && message && (
          <div style={{ margin: 16 }}>
            <Alert severity="success">{message} </Alert>
          </div>
        )}

        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Reset Password
        </Typography>
        <form className={classes.form} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                error={error && !password}
                variant="outlined"
                required={true}
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                value={password}
                autoComplete="current-password"
                helperText={error ? "Password Required" : ""}
                onChange={(event) => handlePassword(event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                error={error && !confirmPassword}
                variant="outlined"
                required={true}
                fullWidth
                name="confirmpassword"
                label="Confirm password"
                type="password"
                id="confirmpassword"
                value={confirmPassword}
                helperText={error ? "Confrim Password Required" : ""}
                onChange={(event) => handleConfirmPassword(event.target.value)}
              />
            </Grid>
          </Grid>
          {error && message && (
            <div style={{ margin: 16 }}>
              <Alert severity="error">{message} </Alert>
            </div>
          )}

          <Button
            type="button"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={() => handleSubmit()}
          >
            Reset Password
          </Button>
        </form>
      </div>
      <Box mt={5}>
        <Copyright />
      </Box>
    </Container>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: red[400],
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: red[400],
    "&:hover": {
      backgroundColor: red[200],
    },
  },
}));
